function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.375 1.68762H14.625V5.62512H13.5V2.81262L4.5 2.81262V5.62512H3.375V1.68762Z",
  fill: "#7A7A7A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.375 16.3126H14.625V12.3751H13.5V15.1876L4.5 15.1876V12.3751H3.375V16.3126Z",
  fill: "#7A7A7A"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.92804 10.6877L4.2446 9.70055H3.49029V10.6877H2.67017V7.14398H4.2041C4.51798 7.14398 4.78967 7.19629 5.01917 7.30092C5.25204 7.40554 5.43092 7.55404 5.55579 7.74642C5.68067 7.93879 5.7431 8.16661 5.7431 8.42986C5.7431 8.69311 5.67898 8.92092 5.55073 9.11329C5.42585 9.30229 5.24698 9.44742 5.0141 9.54867L5.80892 10.6877H4.92804ZM4.91285 8.42986C4.91285 8.23073 4.84873 8.07886 4.72048 7.97423C4.59223 7.86623 4.40492 7.81223 4.15854 7.81223H3.49029V9.04748H4.15854C4.40492 9.04748 4.59223 8.99348 4.72048 8.88548C4.84873 8.77748 4.91285 8.62561 4.91285 8.42986Z",
  fill: "#7A7A7A"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.7267 9.92836H7.08138L6.76751 10.6877H5.92713L7.50663 7.14398H8.31663L9.9012 10.6877H9.04057L8.7267 9.92836ZM8.46851 9.30567L7.90657 7.94892L7.34463 9.30567H8.46851Z",
  fill: "#7A7A7A"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M15.4322 7.14398L14.2729 10.6877H13.392L12.6124 8.28811L11.8074 10.6877H10.9316L9.76724 7.14398H10.6177L11.4176 9.63473L12.2529 7.14398H13.0123L13.8223 9.65498L14.6475 7.14398H15.4322Z",
  fill: "#7A7A7A"
});

function SvgRawData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawData);
export default __webpack_public_path__ + "static/media/raw_data.1a12f6e0.svg";
export { ForwardRef as ReactComponent };